/* eslint-disable */
import {
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
  Button,
  Dropdown,
  Modal,
  message,
  Upload,
  Row,
  Col,
  Typography,
  Tag,
} from "antd";
import React, { useEffect, useRef, useState, useMemo,} from "react";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  MenuOutlined,
  EditOutlined,
  PlusOutlined,
  FileTextOutlined,
  FileSearchOutlined,
  DeleteOutlined,
  UploadOutlined,
  FormOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { dataTo12Fn } from "@/utils/date";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import AddModal from "./component/addModal";
import EditModal from "./component/editModal";
// import ViewModal from "./component/editPolicyPage";
import UploadModal from "./component/uploadModal";
import UploadToExcelModal from "./component/uploadExcelModal";
import UploadLiabilityModal from "./component/uploadLiabilityModal";
import EnterPaymentModal from "./component/enterPaymentModal" ;
import "./component/index.css";
export default function InsuranceIndex() {
  const addModalRef = useRef(null);
  const EditModalRef = useRef(null);
  const ViewModalRef = useRef(null);
  const UploadModalRef = useRef(null);
  const UploadToExcelModalRef = useRef(null);
  const uploadLiabilityModalRef = useRef(null);
  const insuranceEditDetailRef = useRef(null);
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [anetTypeOptions, AnetTypeOptions] = useState([]);
  const [excelUploading, setExcelUploading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 1000,
    total: 0,
  });
  const pageSizeRef = useRef(1000);
  const [insuranceTypeOptions, setInsuranceTypeOptions] = useState([]);
  const [highlightRowId, setHighlightRowId] = useState(null);
  // 上传Excel
  const [pendingFile, setPendingFile] = useState(null);
  const [checkModalVisible, setCheckModalVisible] = useState(false);
  const [checkResult, setCheckResult] = useState(null);
  const [checkMsg, setCheckMsg] = useState("");
  const [foreignId, setForeignId] = useState(null);
  const buildColumns = (checkedValues = selectedItems) =>
    initColumns.map((item) => ({
      ...item,
      hidden:
        checkedValues?.length > 0
          ? !checkedValues.includes(item.dataIndex)
          : false,
    }));
  // 处理选项变化
  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    setColumns(buildColumns(checkedValues));
  };

  const showModal = () => {
    addModalRef.current?.setModelAdd();
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  const handleMenuClick = async (e, record) => {
    if (e.key === "Edit") {
      // EditModalRef.current?.open(record);
      // return;
         window.open(`/#/AccountPayable/InsuranceEnterPaymentPage?id=${record.id}`, "_blank");
         return;
    }
    if (e.key === "View") {
      // ViewModalRef.current?.open(record);
      // return;
      // 原弹窗 改为page页面打开
       window.open(`/#/AccountPayable/InsuranceEditPolicyPage?id=${record.id}`, "_blank");
         return;
    }
    if (e.key === "Upload") {
      UploadModalRef.current?.open(record);
      return;
    }
if (e.key === "Delete") {
  // 定义递归确认函数
  const confirmDelete = async (id, confirmStep = 0, closeParentModal = null) => {
    // 第一次调用或后续确认调用
    const apiUrl = confirmStep === 0 ? api.getInstanceDel : api.getInstanceDelConfirm;
    const params = confirmStep === 0 
      ? { id } 
      : { id, confirm: "true" };
    
    try {
      const res = await http.get(apiUrl, { params });
      
      if (res?.code === "1") {
        const data = res?.data;
        
        // data === 0: 删除成功
        if (data === 0) {
          message.success("Delete Successfully.");
          getTableListFn(
            pagination.current,
            pageSizeRef.current,
            tableHead,
          );
          return true;
        }
        
        // data === 1 或 2: 需要继续确认
        if (data === 1 || data === 2) {
          return new Promise((resolve) => {
            Modal.confirm({
              title: "Confirm Delete",
              content: res?.msg || "Are you sure you want to continue?",
              okText: "Confirm",
              okType: "danger",
              cancelText: "Cancel",
              centered: true,
              onOk: async () => {
                const result = await confirmDelete(id, confirmStep + 1);
                resolve(result);
              },
              onCancel: () => {
                resolve(false);
              },
            });
          });
        }
        
        // data === 3 或 4: 显示错误信息弹窗
        if (data === 3 || data === 4) {
          return new Promise((resolve) => {
            Modal.info({
              title: "Delete Failed",
              content: res?.msg || "Delete failed.",
              okText: "OK",
              centered: true,
              onOk: () => {
                resolve(false);
              },
            });
          });
        }
      } else {
        message.error(res?.msg || "Request Error");
        return false;
      }
    } catch (err) {
      message.error("Request Error");
      return false;
    }
  };

  // 显示第一次确认弹窗
  Modal.confirm({
    title: "Confirm Delete",
    content: "Are you sure you want to delete this policy?",
    okText: "Delete",
    okType: "danger",
    cancelText: "Cancel",
    centered: true,
    onOk: async () => {
      await confirmDelete(record?.id, 0);
    },
    onCancel: () => {
      // 用户取消第一次确认
    },
  });
}
     if (e.key === "EditDeductLimit") {
      uploadLiabilityModalRef.current?.open(record);
      return;
    }
  };

  const getAgentTypeList = async () => {
    try {
      const res = await http.get(api.getAgentType);
      const data = res?.data || res;
      const list = (data || []).map((item) => ({
        value: item.vendorId,
        label: item.vendorName,
      }));

      AnetTypeOptions(list);
    } catch (err) {
      message.error("Request Error");
    }
  };


  const initTableHead = {
   expirationDate: null,
  effectiveDate: null,
  policyNumber: null,
  carrier: null,
  agent: null,
  payee: null,
  remark: null,
  openStatus: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    if (type === "DatePicker") {
      setTableHead((prev) => {
        const updatedTableHead = {
          ...prev,
          // [key]: event || undefined,
           [key]: event ? event.format("YYYY-MM-DD") : undefined,
        };
        getTableListFn(1, pageSizeRef.current, updatedTableHead);
        return updatedTableHead;
      });
      return;
    }
    commonFn.tableFilterFn({ event, key, type, setTableHead,  getTableListFn: (current, pageSize, tableHead) => {
      getTableListFn(current, pageSizeRef.current, tableHead);
    } });
  };
  const paymentColumns = () => {
    return [0, 1, 2].map((item) => ({
      title: "Last Payment",
      dataIndex: `lastPayment_${item}`,
      width: 120,
      onCell: () => ({
        style: {
          padding: "8px",
          cursor: "pointer", 
        },
      }),
      render: (text, record) => {
        const { lastPayments } = record;
        const payment = (lastPayments || [])[item];
        if (!payment) return <div>-</div>;
        const { amount, paymentColor, paymentDate, pushBatch } = payment;
        const colorMatch = {
          0: "#3c8dbc",
          1: "#dd4b39",
          2: "green",
          3: "#f39c12",
        };
        const titleMatch = {
          0: "(Pending)",
          1: "(Not Cash)",
          2: "(Cashed)",
          3: "(Voided)",
        };

        const textColor = colorMatch[paymentColor] || "";
        const title = titleMatch?.[paymentColor] || "";

        return (
          <div style={{ color: textColor, cursor: "pointer" }} onClick={() => handleRowClick(record, pushBatch)}>
            {(title && (
              <span
                style={{
                  borderBottom: `1px dashed ${textColor}`,
                  paddingBottom: "2px",
                }}
              >
                {title}
              </span>
            )) ||
              null}
            <br />
            <span
              style={{
                borderBottom: `1px dashed ${textColor}`,
                paddingBottom: "2px",
              }}
            >
              {paymentDate ? moment(paymentDate).format("MM/DD/YYYY") : "-"}
            </span>
            <br />
            <span
              style={{
                borderBottom: `1px dashed ${textColor}`,
                paddingBottom: "2px",
              }}
            >
              {amount
                ? new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2,
                  }).format(parseFloat(amount))
                : "-"}
            </span>
          </div>
        );
      },
    }));
  };
  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "bankId",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) => {
        const menuItems = [
            //原view 改成edit policy -- 原Edit改为enter payment 不改key ，
          commonFn.btnAuthorityFlag("Edit") && {
            key: "Edit",
            icon: <EditOutlined style={{ color: "#00c0ef", fontSize: 17 }} />,
            label: <div>Enter Payment</div>,
          },
          commonFn.btnAuthorityFlag("View") && {
            key: "View",
            icon: (
              <FileSearchOutlined style={{ color: "#00c0ef", fontSize: 17 }} />
            ),
            label: <div>Edit Policy</div>,
          },
        
           commonFn.btnAuthorityFlag("EditDeductLimit") && record.isPayment &&  {
            key: "EditDeductLimit",
            icon: (
              <FormOutlined style={{ color: "#00c0ef", fontSize: 17 }} />
            ),
            label: <div>Edit Deduct&Limit</div>,
          },
          commonFn.btnAuthorityFlag("Upload") && {
            key: "Upload",
            icon: (
              <FileTextOutlined style={{ color: "#00c0ef", fontSize: 17 }} />
            ),
            label: <div>Upload Policy</div>,
          },
          commonFn.btnAuthorityFlag("Delete") && {
            key: "Delete",
            icon: <DeleteOutlined style={{ color: "#00c0ef", fontSize: 17 }} />,
            label: <div>Delete Policy</div>,
          },
        ].filter(Boolean);

        return (
          (menuItems.length > 0 && (
            <Dropdown
              menu={{
                items: menuItems,
                onClick: (e) => handleMenuClick(e, record),
              }}
              trigger={["click"]}
            >
              <MenuOutlined
                style={{ cursor: "pointer", fontSize: 16, color: "#0e78a9" }}
              />
            </Dropdown>
          )) ||
          null
        );
      },
    },

    {
      title: "Expiration Date",
      dataIndex: "expirationDate",
      titleType: "DatePicker",
      // onChange: (_, dateString) =>
      // tableFilterFn(dateString, "expirationDate", "DatePicker"),
      onChange: (date) => tableFilterFn(date, "expirationDate", "DatePicker"),
      render: (value) => dataTo12Fn(value, 2),
    },
    {
      title: "Effective Date",
      dataIndex: "effectiveDate",
      titleType: "DatePicker",
      // onChange: (_, dateString) =>
      // tableFilterFn(dateString, "effectiveDate", "DatePicker"),
      onChange: (date) => tableFilterFn(date, "effectiveDate", "DatePicker"),
      render: (value) => dataTo12Fn(value, 2),
    },
    {
      title: "Policy Number",
      dataIndex: "policyNumber",
      titleType: "Input",
      sortterMultiple: 2,
      onChange: (e) => tableFilterFn(e, "policyNumber"),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      width: 100,
      isAmountFlag: true,
    },

    {
      title: "# of Prop",
      dataIndex: "numberOfProperties",
      width: 80,
    },

    {
      title: "Carrier",
      dataIndex: "carrier",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "carrier"),
    },
    {
      title: "Agent",
      dataIndex: "agent",
      titleType: "Select",
      width:200,
      selectOptions: anetTypeOptions,
      onChange: (e) => tableFilterFn(e, "agent", "Select"),
    },
      {
      title: "Payee",
      dataIndex: "payee",
      titleType: "Select",
      width:200,
      selectOptions: anetTypeOptions,
      onChange: (e) => tableFilterFn(e, "payee", "Select"),
    },
    ...paymentColumns(),
    {
      title: "Status",
      dataIndex: "openStatus",
      titleType: "Select",
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: [
        { label: "Open", value: "1" },
        { label: "Close", value: "0" },
      ],
      onChange: (e) => tableFilterFn(e, "openStatus", "Select"),
      render: (text, record) => {
        const { id } = record;
        const isOpen = Number(text) === 1;

        const handleClick = () => {
          let confirmLoading = false;

          const modalInstance = Modal.confirm({
            title: "Confirm Status Change",
            centered: true,
            content: (
              <div>
                <div style={{ textAlign: "center" }}>
                  Are you sure you want to change the status to
                  <span style={{ color: "#1890ff", fontWeight: 500 }}>
                    {isOpen ? " Close" : " Open"}
                  </span>
                  ?
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 12,
                    marginTop: 24,
                  }}
                >
                  <Button onClick={() => modalInstance.destroy()}>
                    Cancel
                  </Button>

                  <Button
                    type="primary"
                    loading={confirmLoading}
                    onClick={async () => {
                      if (confirmLoading) return;
                      confirmLoading = true;
                      modalInstance.update({
                        content: (
                          <div>
                            <div style={{ textAlign: "center" }}>
                              Are you sure you want to change the status to
                              <span
                                style={{ color: "#1890ff", fontWeight: 500 }}
                              >
                                {isOpen ? " Close" : " Open"}
                              </span>
                              ?
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                gap: 12,
                                marginTop: 24,
                              }}
                            >
                              <Button
                                onClick={() => modalInstance.destroy()}
                                disabled={true}
                              >
                                Cancel
                              </Button>

                              <Button
                                type="primary"
                                loading={true}
                                disabled={true}
                              >
                                Confirm
                              </Button>
                            </div>
                          </div>
                        ),
                      });

                      try {
                        const response = await http.get(
                          api.getInsuranceOpenStatus,
                          {
                            params: {
                              id,
                              openStatus: isOpen ? 0 : 1,
                            },
                          },
                        );

                        if (response?.code === "1") {
                          message.success("Status updated successfully");
                          getTableListFn(
                            pagination.current,
                            pageSizeRef.current,
                            tableHead,
                          );
                        }
                      } catch (error) {
                        message.error("Status update failed");
                      } finally {
                        modalInstance.destroy();
                      }
                    }}
                  >
                    Confirm
                  </Button>
                </div>
              </div>
            ),
            footer: null,
          });
        };
        return (
          <Tag
            color={isOpen ? "green" : "red"}
            style={{ cursor: "pointer" }}
            onClick={handleClick}
          >
            {isOpen ? "Open" : "Close"}
          </Tag>
        );
      },
    },
  ];

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pageSizeRef.current,
      foreignId: foreignId,
      ...tableHead,
    };
    //
    const response = await http.get(api.getInsuranceShow, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
      key: item.id,
    }));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    pageSizeRef.current = pagination.pageSize;
    const { field: orderField, order: orderType, columnKey } = sorter;
    if (columnKey === "trust") {
      const tableHeadTemp = {
        ...tableHead,
        orderField,
        orderType,
      };
      getTableListFn(pagination.current, pageSizeRef.current, tableHeadTemp);
    } else {
      getTableListFn(pagination.current, pageSizeRef.current, tableHead);
    }
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
    setColumns(buildColumns(transformedList2));
  };

  const handleRowClick = (record, pushBatch) => {
  insuranceEditDetailRef.current?.openModal({
    record: record,
    pushBatch: pushBatch
  });
};


  useEffect(() => {
    initColunmsFn();
    getAgentTypeList();
    getTableListFn(1, pageSizeRef.current);
 
  }, [refreshKey,foreignId]);

  useEffect(() => {
    setColumns(buildColumns(selectedItems));
  }, [anetTypeOptions, selectedItems]);

useEffect(() => {
  const handler = (event) => {
    if (event.data?.type === "INSURANCE_REFRESH") {
      getTableListFn(
        pagination.current,
        pageSizeRef.current,
        tableHead
      );
    }
  };

  window.addEventListener("message", handler);
  return () => window.removeEventListener("message", handler);
}, [pagination.current, pageSizeRef.current, tableHead]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start" >
        <Space>
          {commonFn.btnAuthorityFlag("New") && (
            <Button className="btnNew" onClick={showModal}>
              <PlusOutlined />
              New
            </Button>
          )}
          {commonFn.btnAuthorityFlag("UploadExcel") && (
            <Button
              className="btnNew"
              onClick={() => {
                UploadToExcelModalRef.current?.open({
                  type: "transactions",
                });
              }}
            >
              <UploadOutlined />
              Upload
            </Button>
          )}
        </Space>
        <div className="min-width">
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={() => setRefreshKey(+new Date())}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="340px"
        tableCss="maintenanceTable"
        rowKey="id"
         rowClassName={(record) => record.id === highlightRowId ? "highlight-row" : ""}
      />
      <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pageSizeRef.current, tableHead);
        }}
      />
      {/* <EditModal
        ref={EditModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      /> */}
      {/* <ViewModal
        ref={ViewModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      /> */}

      <UploadModal
        ref={UploadModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current,pageSizeRef.current, tableHead);
        }}
      />

      <UploadToExcelModal
        ref={UploadToExcelModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pageSizeRef.current, tableHead);
        }}
      />

       <UploadLiabilityModal
        ref={uploadLiabilityModalRef}
         onSuccess={() => {
        getTableListFn(pagination.current, pageSizeRef.current, tableHead);
        }}
        />
      <EnterPaymentModal ref={insuranceEditDetailRef} />
    </div>
  );
}
